module.exports = __webpack_public_path__ + "img/前往.90036982.png";